import { useEffect, useState } from 'react';

export type PixelArea = 'begin register' | 'registered';

let idForPixelArea: Map<PixelArea, string> = new Map([
  ['begin register', '8048968682'],
  ['registered', '8048968898']
]);

const useBonnierPixel = (area: PixelArea, shouldAppend: boolean) => {
  const [appended, setAppended] = useState(false);

  useEffect(() => {
    var ordinal = String(Math.floor(Math.random() * 10000000000000000));
    let pixelUrl = `https://pubads.g.doubleclick.net/activity;dc_iu=/34405621/DFPAudiencePixel;ord=${ordinal};dc_seg=${idForPixelArea.get(
      area
    )}?`;
    let scriptSource = `(function() {new Image().src = '${pixelUrl}';})();`;

    // They want another pixel here apparently.
    if (area === 'registered') {
      scriptSource += `\n(function() { var a = String(Math.floor(Math.random() * 10000000000000000)); new Image().src = 'https://pubads.g.doubleclick.net/activity;xsp=5191687;ord='+ a +'?'; })();`;
    }

    const script = document.createElement('script');
    script.innerHTML = scriptSource;

    if (shouldAppend && !appended) {
      console.log('appending');
      document.body.appendChild(script);
      setAppended(true);
    }
  }, [area, shouldAppend, appended]);
};

export default useBonnierPixel;
